import { createContext } from "react";

const HeaderOffsetContext = createContext({
    marqueeHeight: 0,
    desktop: {
        gap: 0,
        topOffset: 0,
        navHeight: 0,
        totalHeight: 0,
    },
    mobile: {
        gap: 0,
        topOffset: 0,
        navHeight: 0,
        totalHeight: 0,
    },
});

export default HeaderOffsetContext;


